"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeaderPortal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IpisLogoIconV2_1 = require("../../components/branding/IpisLogoIconV2");
var IpisBackButton_1 = require("../../components/nav/IpisBackButton");
var framer_motion_1 = require("framer-motion");
var brand_hooks_1 = require("../../hooks/brand-hooks");
var nav_hooks_1 = require("../../hooks/nav-hooks");
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var react_router_dom_1 = require("react-router-dom");
var client_utils_1 = require("../../utils/client-utils");
var PageHeaderPortal = function (props) {
    var theme = (0, brand_hooks_1.useExternalBrandTheme)().externalBrandTheme;
    var _a = (0, react_1.useState)(false), setRerenderHack = _a[1];
    function rerender() {
        setRerenderHack(function (prev) { return !prev; });
    }
    var headerId = "page-header";
    var element = document.getElementById(headerId);
    var previousPageIsTheSame = (0, nav_hooks_1.useIsPreviousPageFromCurrentSite)();
    var params = (0, react_router_dom_1.useSearchParams)()[0];
    var goBackTo = params.get("goBackTo");
    var overrideLink;
    if (props.overrideLink) {
        overrideLink = props.overrideLink;
    }
    else if (!previousPageIsTheSame) {
        overrideLink = props.overrideLinkWhenNoHistory;
    }
    var customBack = overrideLink || !!goBackTo;
    var showBackButton = !props.noBackButton && (previousPageIsTheSame || customBack);
    var rerenderTimeoutRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!element && !rerenderTimeoutRef.current) {
            rerenderTimeoutRef.current = setTimeout(function () {
                rerender();
                rerenderTimeoutRef.current = null;
            }, 100);
        }
    });
    if (!element) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    function constructGridTemplateColumns() {
        return "minmax(max-content, 1fr) auto minmax(0, 1fr)";
    }
    function constructGridTemplateAreas() {
        var subheadingArea = !!props.subHeading ? "subheading" : "heading";
        return "\n        \"leftSlot ".concat(subheadingArea, " rightSlot\"\n        \"leftSlot heading rightSlot\"\n      ");
    }
    return react_dom_1.default.createPortal(
    /*
      We might be able to use a fragment later and move the styling to the PageHeaderV2 component.
      Ill keep the styling here for now to make it easier to develop.
    */
    (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "items-center gap-x-4", style: {
            display: "grid",
            gridTemplateColumns: constructGridTemplateColumns(),
            gridTemplateAreas: constructGridTemplateAreas(),
        }, initial: {
            opacity: 0,
        }, animate: {
            opacity: 1,
        }, children: [(0, jsx_runtime_1.jsxs)("span", { className: "mr-auto flex items-center pl-5", style: {
                    gridArea: "leftSlot",
                }, children: [!showBackButton && !theme && ((0, jsx_runtime_1.jsx)(IpisLogoIconV2_1.IpisLogoIconV2, { size: 50, light: true, logo: props.logo })), !showBackButton && theme && ((0, jsx_runtime_1.jsx)("img", { src: theme.logoUrl, alt: "Logga f\u00F6r ".concat(theme.brandName), className: "max-w-[80px]" })), showBackButton && (0, jsx_runtime_1.jsx)(IpisBackButton_1.IpisBackButton, { overrideLink: overrideLink }), props.leftSlot] }), (0, jsx_runtime_1.jsx)("h1", { className: (0, client_utils_1.classNames)("mx-auto text-center text-base font-semibold md:text-lg", !theme && "text-light-background"), style: {
                    gridArea: "heading",
                }, children: props.heading }), !!props.subHeading && ((0, jsx_runtime_1.jsx)("h2", { className: (0, client_utils_1.classNames)("mx-auto text-sm font-normal ", !theme && "text-secondary-100"), style: {
                    gridArea: "subheading",
                }, children: props.subHeading })), !!props.rightSlot && ((0, jsx_runtime_1.jsx)("div", { 
                // Right padding to make room for fixed sidebar toggle
                className: "hidden items-center justify-end pr-8 lg:flex", style: {
                    gridArea: "rightSlot",
                }, children: props.rightSlot }))] }), element);
};
exports.PageHeaderPortal = PageHeaderPortal;
exports.default = exports.PageHeaderPortal;
